import React, {FC} from 'react';

import {ErrorModalTemplate} from '../../components/DataDisplay';
import {getLocalizedStrings} from '../../services/localization/localizationService';

interface IProps {
    okBtnKey: string;
    cancelBtnKey: string;
    onClose: () => void;
    onTryAgain: () => void;
    isClosePopupFeaturesDisable?: boolean;
    altKey: string;
    ariaLabelTryAgainKey?: string;
    ariaLabelDoItLaterKey?: string;
    ariaLabelCloseKey: string;
}

const FailedPopup: FC<IProps> = (props) => {
    const {
        okBtnKey,
        cancelBtnKey,
        onClose,
        onTryAgain,
        isClosePopupFeaturesDisable,
        altKey,
        ariaLabelTryAgainKey,
        ariaLabelDoItLaterKey,
        ariaLabelCloseKey,
    } = props;
    const localizedStrings = getLocalizedStrings();
    const cancelBtn = cancelBtnKey
        ? {
              onClick: onClose,
              textKey: cancelBtnKey,
              ariaLabelKey: ariaLabelDoItLaterKey,
          }
        : undefined;
    const buttonPrimary = okBtnKey
        ? {
              isConnectionTrack: true,
              onClick: onTryAgain,
              textKey: okBtnKey,
              ariaLabelKey: ariaLabelTryAgainKey,
          }
        : cancelBtn;
    const buttonSecondary = okBtnKey ? cancelBtn : undefined;

    return (
        <ErrorModalTemplate
            alt={localizedStrings[altKey]}
            isCloseVisible={!isClosePopupFeaturesDisable}
            closeButtonAriaLabel={localizedStrings[ariaLabelCloseKey]}
            buttonPrimary={buttonPrimary}
            buttonSecondary={buttonSecondary}
            {...props}
        />
    );
};

export default FailedPopup;
